/** Nodes the addon builds as node groups, because Blender has no node type for them. */
export enum ColormassNodeName {
    CmBsdfPrincipled = "CmBsdfPrincipled",
    CmScannedTransmission = "CmScannedTransmission",
    CmTextureFromSet = "CmTextureFromSet",
    CmTextureSet = "CmTextureSet",
}

/**
 * Every node type a Blender shader tree accepts in any version we support, so every name an upload can
 * carry. Verified against real Blender binaries by node-name.test.ts. ShaderNodeBsdfGlossy is the one
 * entry bpy.types does not hold: Blender takes it in nodes.new() and answers with ShaderNodeBsdfAnisotropic.
 */
export enum BlenderNodeName {
    FunctionNodeInputBool = "FunctionNodeInputBool",
    FunctionNodeInputInt = "FunctionNodeInputInt",
    FunctionNodeInputMenu = "FunctionNodeInputMenu",
    FunctionNodeInputVector = "FunctionNodeInputVector",
    GeometryNodeInputSceneTime = "GeometryNodeInputSceneTime",
    GeometryNodeMenuSwitch = "GeometryNodeMenuSwitch",
    GeometryNodeRepeatInput = "GeometryNodeRepeatInput",
    GeometryNodeRepeatOutput = "GeometryNodeRepeatOutput",
    NodeClosureInput = "NodeClosureInput",
    NodeClosureOutput = "NodeClosureOutput",
    NodeCombineBundle = "NodeCombineBundle",
    NodeEvaluateClosure = "NodeEvaluateClosure",
    NodeFrame = "NodeFrame",
    NodeGroupInput = "NodeGroupInput",
    NodeGroupOutput = "NodeGroupOutput",
    NodeImplicitConversion = "NodeImplicitConversion",
    NodeJoinBundle = "NodeJoinBundle",
    NodeReroute = "NodeReroute",
    NodeSeparateBundle = "NodeSeparateBundle",
    ShaderNodeAddShader = "ShaderNodeAddShader",
    ShaderNodeAmbientOcclusion = "ShaderNodeAmbientOcclusion",
    ShaderNodeAttribute = "ShaderNodeAttribute",
    ShaderNodeBackground = "ShaderNodeBackground",
    ShaderNodeBevel = "ShaderNodeBevel",
    ShaderNodeBlackbody = "ShaderNodeBlackbody",
    ShaderNodeBrightContrast = "ShaderNodeBrightContrast",
    ShaderNodeBsdfAnisotropic = "ShaderNodeBsdfAnisotropic",
    ShaderNodeBsdfDiffuse = "ShaderNodeBsdfDiffuse",
    ShaderNodeBsdfGlass = "ShaderNodeBsdfGlass",
    ShaderNodeBsdfGlossy = "ShaderNodeBsdfGlossy",
    ShaderNodeBsdfHair = "ShaderNodeBsdfHair",
    ShaderNodeBsdfHairPrincipled = "ShaderNodeBsdfHairPrincipled",
    ShaderNodeBsdfMetallic = "ShaderNodeBsdfMetallic",
    ShaderNodeBsdfPrincipled = "ShaderNodeBsdfPrincipled",
    ShaderNodeBsdfRayPortal = "ShaderNodeBsdfRayPortal",
    ShaderNodeBsdfRefraction = "ShaderNodeBsdfRefraction",
    ShaderNodeBsdfSheen = "ShaderNodeBsdfSheen",
    ShaderNodeBsdfToon = "ShaderNodeBsdfToon",
    ShaderNodeBsdfTranslucent = "ShaderNodeBsdfTranslucent",
    ShaderNodeBsdfTransparent = "ShaderNodeBsdfTransparent",
    ShaderNodeBump = "ShaderNodeBump",
    ShaderNodeCameraData = "ShaderNodeCameraData",
    ShaderNodeClamp = "ShaderNodeClamp",
    ShaderNodeCombineColor = "ShaderNodeCombineColor",
    ShaderNodeCombineHSV = "ShaderNodeCombineHSV",
    ShaderNodeCombineRGB = "ShaderNodeCombineRGB",
    ShaderNodeCombineXYZ = "ShaderNodeCombineXYZ",
    ShaderNodeDisplacement = "ShaderNodeDisplacement",
    ShaderNodeEeveeSpecular = "ShaderNodeEeveeSpecular",
    ShaderNodeEmission = "ShaderNodeEmission",
    ShaderNodeFloatCurve = "ShaderNodeFloatCurve",
    ShaderNodeFresnel = "ShaderNodeFresnel",
    ShaderNodeGamma = "ShaderNodeGamma",
    ShaderNodeGroup = "ShaderNodeGroup",
    ShaderNodeHairInfo = "ShaderNodeHairInfo",
    ShaderNodeHoldout = "ShaderNodeHoldout",
    ShaderNodeHueSaturation = "ShaderNodeHueSaturation",
    ShaderNodeInvert = "ShaderNodeInvert",
    ShaderNodeLayerWeight = "ShaderNodeLayerWeight",
    ShaderNodeLightFalloff = "ShaderNodeLightFalloff",
    ShaderNodeLightPath = "ShaderNodeLightPath",
    ShaderNodeMapRange = "ShaderNodeMapRange",
    ShaderNodeMapping = "ShaderNodeMapping",
    ShaderNodeMath = "ShaderNodeMath",
    ShaderNodeMix = "ShaderNodeMix",
    ShaderNodeMixRGB = "ShaderNodeMixRGB",
    ShaderNodeMixShader = "ShaderNodeMixShader",
    ShaderNodeNewGeometry = "ShaderNodeNewGeometry",
    ShaderNodeNormal = "ShaderNodeNormal",
    ShaderNodeNormalMap = "ShaderNodeNormalMap",
    ShaderNodeObjectInfo = "ShaderNodeObjectInfo",
    ShaderNodeOutputAOV = "ShaderNodeOutputAOV",
    ShaderNodeOutputLight = "ShaderNodeOutputLight",
    ShaderNodeOutputLineStyle = "ShaderNodeOutputLineStyle",
    ShaderNodeOutputMaterial = "ShaderNodeOutputMaterial",
    ShaderNodeOutputWorld = "ShaderNodeOutputWorld",
    ShaderNodeParticleInfo = "ShaderNodeParticleInfo",
    ShaderNodePointInfo = "ShaderNodePointInfo",
    ShaderNodeRGB = "ShaderNodeRGB",
    ShaderNodeRGBCurve = "ShaderNodeRGBCurve",
    ShaderNodeRGBToBW = "ShaderNodeRGBToBW",
    ShaderNodeRadialTiling = "ShaderNodeRadialTiling",
    ShaderNodeRaycast = "ShaderNodeRaycast",
    ShaderNodeScript = "ShaderNodeScript",
    ShaderNodeSeparateColor = "ShaderNodeSeparateColor",
    ShaderNodeSeparateHSV = "ShaderNodeSeparateHSV",
    ShaderNodeSeparateRGB = "ShaderNodeSeparateRGB",
    ShaderNodeSeparateXYZ = "ShaderNodeSeparateXYZ",
    ShaderNodeShaderToRGB = "ShaderNodeShaderToRGB",
    ShaderNodeSqueeze = "ShaderNodeSqueeze",
    ShaderNodeSubsurfaceScattering = "ShaderNodeSubsurfaceScattering",
    ShaderNodeTangent = "ShaderNodeTangent",
    ShaderNodeTexBrick = "ShaderNodeTexBrick",
    ShaderNodeTexChecker = "ShaderNodeTexChecker",
    ShaderNodeTexCoord = "ShaderNodeTexCoord",
    ShaderNodeTexEnvironment = "ShaderNodeTexEnvironment",
    ShaderNodeTexGabor = "ShaderNodeTexGabor",
    ShaderNodeTexGradient = "ShaderNodeTexGradient",
    ShaderNodeTexIES = "ShaderNodeTexIES",
    ShaderNodeTexImage = "ShaderNodeTexImage",
    ShaderNodeTexMagic = "ShaderNodeTexMagic",
    ShaderNodeTexNoise = "ShaderNodeTexNoise",
    ShaderNodeTexPointDensity = "ShaderNodeTexPointDensity",
    ShaderNodeTexSky = "ShaderNodeTexSky",
    ShaderNodeTexVoronoi = "ShaderNodeTexVoronoi",
    ShaderNodeTexWave = "ShaderNodeTexWave",
    ShaderNodeTexWhiteNoise = "ShaderNodeTexWhiteNoise",
    ShaderNodeUVAlongStroke = "ShaderNodeUVAlongStroke",
    ShaderNodeUVMap = "ShaderNodeUVMap",
    ShaderNodeValToRGB = "ShaderNodeValToRGB",
    ShaderNodeValue = "ShaderNodeValue",
    ShaderNodeVectorCurve = "ShaderNodeVectorCurve",
    ShaderNodeVectorDisplacement = "ShaderNodeVectorDisplacement",
    ShaderNodeVectorMath = "ShaderNodeVectorMath",
    ShaderNodeVectorRotate = "ShaderNodeVectorRotate",
    ShaderNodeVectorTransform = "ShaderNodeVectorTransform",
    ShaderNodeVertexColor = "ShaderNodeVertexColor",
    ShaderNodeVolumeAbsorption = "ShaderNodeVolumeAbsorption",
    ShaderNodeVolumeCoefficients = "ShaderNodeVolumeCoefficients",
    ShaderNodeVolumeInfo = "ShaderNodeVolumeInfo",
    ShaderNodeVolumePrincipled = "ShaderNodeVolumePrincipled",
    ShaderNodeVolumeScatter = "ShaderNodeVolumeScatter",
    ShaderNodeWavelength = "ShaderNodeWavelength",
    ShaderNodeWireframe = "ShaderNodeWireframe",
}

const colormassNodeNames = new Set<string>(Object.values(ColormassNodeName))

export const isColormassNode = (nodeName: string): boolean => colormassNodeNames.has(nodeName)

/** Every node the exchange format is allowed to name. */
export const ExchangeNodeName = {...ColormassNodeName, ...BlenderNodeName}
export type ExchangeNodeName = ColormassNodeName | BlenderNodeName
